// extracted by mini-css-extract-plugin
export default {"container":"mI-z","disabled":"nI-z","bgBlack":"oI-z","content":"pI-z","countdown":"qI-z","topCaption":"rI-z","topHeading":"sI-z","heading":"tI-z","copy":"uI-z"};